export const getNormalizeColor = (color) => {
  if (color.length === 4)
    return `#${color[1]}${color[1]}${color[2]}${color[2]}${color[3]}${color[3]}`.toUpperCase();

  if (color.includes('rgb'))
    return rgbToHex(color).toUpperCase();;
  return color.toUpperCase();;
};

const rgbToHex = (rgb) => {
  // Extract the numeric values from the input string
  const result = rgb.match(/\d+/g);
  if (!result) return null;

  // Convert the first three values (R, G, B) to hexadecimal
  const hex = result.slice(0, 3).map((num) => {
    const hexValue = parseInt(num, 10).toString(16);
    return hexValue.length === 1 ? '0' + hexValue : hexValue;
  }).join('');

  // If there is an alpha value, convert it to hexadecimal and append it
  if (result[3]) {
    const alpha = Math.round(parseFloat(result[3]) * 255).toString(16);
    return `#${hex}${alpha.length === 1 ? '0' + alpha : alpha}`;
  }

  return `#${hex}`;
};